import {PRESSURE_ROW} from '@/constants/enums';
import * as APPDATA from '@/constants/pcConstAppData';
import {RUN_TIME_MODE} from '@/constants/sequenceContentConstants';
import * as setupActionsType from '@/constants/setupActionsType';
import {consoleLog} from '@/libs/consoleHelper';

export const INITIAL_CUSTOM_OPERATION = {
  Operations: [],
  TempOperations: [], // temporary solutions since the Manual Profile page component needs to refactor caused by the object changes generated on the runtime
  Name: null,
  FileName: null,
  ContentChanged: false,
  IsDepressurizedAtTheEnd: false,
  Message: null,
  Repeat: 1,
  Repeated: 0,
  ChipValve: 6,
  DefaulthPrimeParam: 7,
  Status: APPDATA.DEVICE_STATE.IDLE,
  TimeElapsed: 0,
};

// TODO: need to normalized this store, the store become bigger and some of the property needs to break down into separate store, differentiate by the context could be help (ex. App UI state, profile / procedure state, sensor state, device state, wizard state)
export const initialState = {
  currentPCState: APPDATA.PC_IDLE_STATE,
  prevPCState: APPDATA.PC_IDLE_STATE,
  flowRate: 0,
  finalVolume: 0,
  estimatedFinalConcentration: '0',
  diafiltrationMode: 'None',
  diaphragmVacuumPressure: 0,
  diaphragmPressure: 0,
  diaphragmTiming: 0,
  errorMessage: null,
  isPCRunning: false,
  deviceVersion: null,
  isPriming: false,
  isConcentrating: false,
  isDiafiltrating: false,
  isPCPaused: false,
  // TODO: need to move this into derived context this.CustomOperation group for example
  isManualProfileRunning: false,
  // TODO: need to move this into derived context this.CustomOperation group for example
  isManualProfilePaused: false,
  showWarning: false,
  isAutoCalibrate: false,
  operatingPressure: 0,
  recoveryOfLiquid: 'Air',
  // isShowRecoveryLoading: false,
  isFinishRecovery: false,
  startingVolume: 100,
  startingConcentration: '0',
  valveTiming: 0,
  volumeToStartAt: '0',
  dummyBuffer: '0',
  dummyVolume: '22',
  warningMessage: '',
  bufferVolumeToUse: '0',
  failureMessage: '',

  percentageProgressBar: 0,
  estimateTime: 0,
  progressBarStatus: null,

  dialfiltrationStatus: {
    RefilledBufferVolume: '0',
    ShouldRefilledBuffer: 'false',
  },
  isShowRefillBufferPopUp: false,

  isShowThresholdErrorPopUp: false,

  currentPressure: '0',
  pumpFlowRate: '0',
  concentrationFlowRate: '0',
  currentVolume: '0',
  estimateConcentration: '0',
  estSecondsRemaining: '0',
  secondsElapsed: '0',
  percentageComplete: '0',

  currentBuffer: '0',
  currentIsMoreThan50ml: APPDATA.ENUM.MORE_THAN_50_ML.OFF,
  autoProfileSetupMode: APPDATA.AUTO_PROFILE_STATE.CONCENTRATION,
  autoProfileDiafiltrationMode: APPDATA.FIELD_NAME.DIAFILTRATION_OPTION.NONE,
  profileRunning: {
    [APPDATA.KEY.Id]: -1,
    [APPDATA.KEY.Name]: 'No Profile',
    [APPDATA.KEY.CreatedAt]: '00/00/2018 00:00:00',
    [APPDATA.KEY.ModifiedAt]: '00/00/2018 00:00:00',
    [APPDATA.KEY.Config]: {
      [APPDATA.KEY.StartingVolume]: -1,
      [APPDATA.KEY.StartingConcentration]: -1,
      [APPDATA.KEY.FinalVolume]: -1,
      [APPDATA.KEY.EstimatedFinalConcentration]: -1,
      [APPDATA.KEY.DiafiltrationMode]: -1,
      [APPDATA.KEY.VolumeToStartAt]: -1,
      [APPDATA.KEY.BufferVolumeToUse]: -1,
      [APPDATA.KEY.TotalBufferVolumeToUse]: -1,
      [APPDATA.KEY.OperatingPressure]: -1,
      [APPDATA.KEY.RecoveryOfLiquid]: -1,
      [APPDATA.KEY.FlowRate]: -1,
      [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
      [APPDATA.KEY.DiaphragmPressure]: -1,
      [APPDATA.KEY.DiaphragmTiming]: -1,
      [APPDATA.KEY.DiaphragmTimingOpen]: -1,
      [APPDATA.KEY.DiaphragmTimingClose]: -1,

      [APPDATA.KEY.ValveTiming]: -1,
      [APPDATA.KEY.MembraneCutOffSize]: -1,
      [APPDATA.KEY.ConicalVolume]: -1,
      [APPDATA.KEY.Notes]: -1,
      [APPDATA.KEY.ChipValve]: -1,
      [APPDATA.KEY.MoreThan50ml]: -1,
      [APPDATA.KEY.StartingVolumeFor2ndTube]: -1,
      [APPDATA.KEY.ManualControlThreshold]: -1,
    },
  },
  defaultConfigParams: {},
  defaultConfigAdvSetupParams: {
    [APPDATA.KEY.Id]: -1,
    [APPDATA.KEY.Name]: 'No Advanced Setup',
    [APPDATA.KEY.CreatedAt]: '00/00/2018 00:00:00',
    [APPDATA.KEY.ModifiedAt]: '00/00/2018 00:00:00',
    [APPDATA.KEY.ConfigAdvSetup]: {
      [APPDATA.KEY.GeneralAdvSetup]: {
        [APPDATA.KEY.MembraneFillingCycle]: -1,
        [APPDATA.KEY.SkipPriming]: -1,
        [APPDATA.KEY.ManualControlThreshold]: -1,
      },
      [APPDATA.KEY.MainAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
      },
      [APPDATA.KEY.DiafiltrationAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.PrimeAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.RecoveryAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.TubeMixingAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.RecirculateAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
    },
  },
  defaultReturnValvePressure: [
    {
      [APPDATA.KEY.MembraneCutOffSize]: '3',
      [APPDATA.KEY.ReturnValvePressure]: '',
    },
    {
      [APPDATA.KEY.MembraneCutOffSize]: '5',
      [APPDATA.KEY.ReturnValvePressure]: '',
    },
    {
      [APPDATA.KEY.MembraneCutOffSize]: '10',
      [APPDATA.KEY.ReturnValvePressure]: '',
    },
    {
      [APPDATA.KEY.MembraneCutOffSize]: '30',
      [APPDATA.KEY.ReturnValvePressure]: '',
    },
    {
      [APPDATA.KEY.MembraneCutOffSize]: '50',
      [APPDATA.KEY.ReturnValvePressure]: '',
    },
    {
      [APPDATA.KEY.MembraneCutOffSize]: '100',
      [APPDATA.KEY.ReturnValvePressure]: '',
    },
    {
      [APPDATA.KEY.MembraneCutOffSize]: '300',
      [APPDATA.KEY.ReturnValvePressure]: '',
    },
  ],
  checkProfileParam: false,
  srcCheckProfileParam: '',
  refilledBufferVolume: APPDATA.EMPTY_FIELD,
  isNeedUpdateSensorModalRefillBuffer: false,
  // TODO: need to revalidate again the object properties of recoveryOfLiquidStatus (reff. StatusRecoveryOfLiquid class in backend)
  recoveryOfLiquidStatus: {
    [APPDATA.KEY.CurrentRecoveryStatus]: APPDATA.ENUM.RECOVERY_OF_LIQUID.None,
    [APPDATA.KEY.CurrentRunTime]: '0',
    [APPDATA.KEY.RecoveryOfLiquidState]: APPDATA.ENUM.RECOVERY_OF_LIQUID.None,
    [APPDATA.KEY.TotalRunTime]: '0',
    [APPDATA.KEY.CycleCount]: '0',
    [APPDATA.KEY.IsComplete]: 'False',
    [APPDATA.KEY.NumberOfCycle]: '0',
  },
  advSetupChoosen: {
    [APPDATA.KEY.Id]: -1,
    [APPDATA.KEY.Name]: 'No Advanced Setup',
    [APPDATA.KEY.CreatedAt]: '00/00/2018 00:00:00',
    [APPDATA.KEY.ModifiedAt]: '00/00/2018 00:00:00',
    [APPDATA.KEY.ConfigAdvSetup]: {
      [APPDATA.KEY.GeneralAdvSetup]: {
        [APPDATA.KEY.MembraneFillingCycle]: -1,
        [APPDATA.KEY.SkipPriming]: -1,
        [APPDATA.KEY.ManualControlThreshold]: -1,
      },
      [APPDATA.KEY.MainAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
      },
      [APPDATA.KEY.DiafiltrationAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.PrimeAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.RecoveryAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.TubeMixingAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.RecirculateAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
    },
  },
  currentTiming: {
    [APPDATA.KEY.DiaphragmTiming]: -1,
    [APPDATA.KEY.DiaphragmTimingOpen]: -1,
    [APPDATA.KEY.DiaphragmTimingClose]: -1,
    [APPDATA.KEY.ValveTiming]: -1,
  },
  transferVolume: '',
  requireRefill: '',
  isStopingFromButton: false,
  activeMenu: 'None',
  primeTiming: '20',
  // explorer
  profileList: null,
  profileSelected: undefined,
  profileName: 'No Profile',
  profileSettingExplorer: null,
  showProfile: null,
  lastProfileIdView: 0,
  profileAddress: null,
  updateProfileList: false,
  resetPreviewProfile: false,
  saveProfile: false,
  invalidAutoProfileParams: [],
  currentProfileParams: {
    [APPDATA.KEY.StartingVolume]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.StartingConcentration]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.FinalVolume]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.EstimatedFinalConcentration]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.VolumeToStartAt]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.BufferVolumeToUse]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.DiafiltrationMode]: APPDATA.FIELD_NAME.NONE_DIAFILTRATION,
    [APPDATA.KEY.ExchangeStepSize]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.StepSizeVolume]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.MembraneCutOffSize]: undefined,
    [APPDATA.KEY.MembraneType]: undefined,
    [APPDATA.KEY.ConicalVolume]: undefined,
    [APPDATA.KEY.TotalBufferVolumeToUse]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.ChipValve]: APPDATA.ENUM.TOTAL_VALVE_IN_CHIP.Six,
    [APPDATA.KEY.MoreThan50ml]: APPDATA.ENUM.MORE_THAN_50_ML.OFF,
    [APPDATA.KEY.StartingVolumeFor2ndTube]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.IdAdvSetup]: APPDATA.EMPTY_FIELD,
  },
  templateNewProfile: {},
  templateAutoProfile: {
    [APPDATA.KEY.StartingVolume]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.StartingConcentration]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.FinalVolume]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.EstimatedFinalConcentration]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.VolumeToStartAt]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.BufferVolumeToUse]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.DiafiltrationMode]: APPDATA.FIELD_NAME.NONE_DIAFILTRATION,
    [APPDATA.KEY.ExchangeStepSize]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.StepSizeVolume]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.MembraneCutOffSize]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.MembraneType]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.ConicalVolume]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.TotalBufferVolumeToUse]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.ChipValve]: APPDATA.ENUM.TOTAL_VALVE_IN_CHIP.Six,
    [APPDATA.KEY.MoreThan50ml]: APPDATA.ENUM.MORE_THAN_50_ML.OFF,
    [APPDATA.KEY.StartingVolumeFor2ndTube]: APPDATA.EMPTY_FIELD,
    [APPDATA.KEY.IdAdvSetup]: APPDATA.EMPTY_FIELD,
  },

  // Auto Profile
  isCompleteFill: false,

  // adv setup explorer
  advSetupList: null,
  advSetupSelected: undefined,
  advSetupName: 'No Advanced Setup',
  advSetupSettingExplorer: null,
  showAdvSetup: null,
  lastAdvSetupIdView: 0,
  lastAdvSetupIdCreated: 0,
  advSetupAddress: null,
  updateAdvSetupList: false,
  resetPreviewAdvSetup: false,
  saveAdvSetup: false,
  currentAdvSetupParams: {
    [APPDATA.KEY.Id]: -1,
    [APPDATA.KEY.Name]: 'No Advanced Setup',
    [APPDATA.KEY.CreatedAt]: '00/00/2018 00:00:00',
    [APPDATA.KEY.ModifiedAt]: '00/00/2018 00:00:00',
    [APPDATA.KEY.ConfigAdvSetup]: {
      [APPDATA.KEY.GeneralAdvSetup]: {
        [APPDATA.KEY.MembraneFillingCycle]: -1,
        [APPDATA.KEY.SkipPriming]: -1,
        [APPDATA.KEY.ManualControlThreshold]: -1,
        [APPDATA.KEY.SkipPriming]: false,
        [APPDATA.KEY.MixingSetup]: {
          [APPDATA.KEY.AutoMixingOn]: false,
          [APPDATA.KEY.MixingCycle]: -1,
          [APPDATA.KEY.MixingMinutes]: -1,
        },
      },
      [APPDATA.KEY.MainAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
      },
      [APPDATA.KEY.DiafiltrationAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.PrimeAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.RecoveryAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.TubeMixingAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
      [APPDATA.KEY.RecirculateAdvSetup]: {
        [APPDATA.KEY.PressureAdvSetup]: {},
        [APPDATA.KEY.DefaultReturnValvePressure]: null,
        // [APPDATA.KEY.DiaphragmVacuumPressure]: -1,
        // [APPDATA.KEY.DiaphragmPressure]: -1,
        // [APPDATA.KEY.OperatingPressure]: -1,
        [APPDATA.KEY.DiaphragmTiming]: -1,
        [APPDATA.KEY.DiaphragmTimingOpen]: -1,
        [APPDATA.KEY.DiaphragmTimingClose]: -1,

        [APPDATA.KEY.ValveTiming]: -1,
        [APPDATA.KEY.Duration]: -1,
      },
    },
  },
  currentVolumeChangesThreshold: 0,
  currentPressureSensors: {
    [APPDATA.ENUM.PRESSURE[PRESSURE_ROW.SOURCE]]: 0,
    [APPDATA.ENUM.PRESSURE[PRESSURE_ROW.VACUUM]]: 0,
    [APPDATA.ENUM.PRESSURE[PRESSURE_ROW.DIAPHRAGM]]: 0,
    [APPDATA.ENUM.PRESSURE[PRESSURE_ROW.BOTTLE]]: 0,
  },
  ErrorVolumeChanges: {CurrentChanges: 0, ErrorType: 0, Threshold: 0, ThresholdPct: null},
  templateNewAdvSetup: {},
  editAdvSetup: false,
  disableSaveSetupButton: false,
  buttonTypeAdv: null,
  // ALERT
  alertShow: false,
  alertText: '',
  alertStyle: 'alert-success',

  // showLoading: false,
  // loadingText: undefined,
  // loadingClickEvent: undefined,
  // loadingButton: undefined,

  // auto profile help
  modeHelp: undefined,

  // save config
  saveCycleThreshold: false,

  // top menu
  defaultTopButtonProperties: {
    id: 'default',
    label: 'Top Button',
    disabled: false,
    onClick() {
      consoleLog('OnClick Top button');
    },
  },
  defaultBackButtonProperties: {
    id: APPDATA.BACK,
    label: '',
    disabled: false,
    onClick() {
      consoleLog('OnClick Back button');
    },
  },
  topButtonProperties: {
    id: 'default',
    label: 'label',
    disabled: false,
    onClick() {
      consoleLog('OnClick button');
    },
  },
  backButtonProperties: {
    id: 'default',
    label: 'label',
    disabled: false,
    onClick() {
      consoleLog('OnClick button');
    },
  },
  topButtonSecondaryButtonProperties: undefined,
  topButtonTertiaryButtonProperties: undefined,
  // {
  //     id : "Reset default",
  //     label : "Reset default",
  //     disabled : false,
  //     onClick : function(){
  //         consoleLog ("OnClick button")
  //     }
  // },
  titleMenuProperties: 'Title',
  lockAccess: undefined,
  modifyProfile: true,
  modifyAdvSetup: true,
  isDoubleButton: false,
  isShowTopButton: false,
  isSecondaryButton: false,
  isTertiaryButton: false,
  isShowActiveMenu: true,
  button1Properties: {
    id: 'default',
    label: 'label',
    disabled: false,
    onClick() {
      consoleLog('OnClick button');
    },
  },
  button2Properties: {
    id: 'default',
    label: 'label',
    disabled: false,
    onClick() {
      consoleLog('OnClick button');
    },
  },

  // infoand support
  fontSize: APPDATA.SMALL_FONT_SIZE,
  // usbfile update
  /**
   * @deprecated
   */
  isOpenFile: false,
  openFileLicense: false,
  usbProperties: undefined,
  usbOpenFor: undefined,
  selectedFileUpdate: undefined,
  selectedFileExport: [],
  selectedDateBeginExport: '',
  selectedDateEndExport: '',
  selectedFolderExportDestination: undefined,

  expandAccordionStatus: true,

  nextActionWizard: false,
  prevActionWizard: false,
  // cleaningProp :
  cleaningProperties: {
    isCleaningWizardRunning: false,
    cleaningDuration: undefined,
    cleaningSolution: 25,
    valveChipType: 6,
    [APPDATA.KEY.MembraneCutOffSize]: undefined,
    [APPDATA.KEY.ConicalVolume]: undefined,
  },
  defaultLowPressureParam: {
    // 0: 19.5,
    // 1: -9,
    // 2: 4
    0: 30,
    1: -9,
    2: 20,
    3: 25,
  },
  defaultHighPressureParam: {
    // 0: 49,
    // 1: -9,
    // 2: 19.5
    0: 50,
    1: -9.25,
    2: 40,
    3: 15,
  },

  defaultLowSeqParam: {
    [APPDATA.KEY.DiaphragmTimingOpen]: '500',
    [APPDATA.KEY.DiaphragmTimingClose]: '500',
    [APPDATA.KEY.ValveTiming]: '50',
  },
  defaultHighSeqParam: {
    [APPDATA.KEY.DiaphragmTimingOpen]: '275',
    [APPDATA.KEY.DiaphragmTimingClose]: '275',
    [APPDATA.KEY.ValveTiming]: '25',
  },
  defaultPressureTemplate: {
    Id: '-1',
    Sequence: 'pressure_changes',
    Repeat: '1',
    Active: true,
    Running: false,
    SequenceParams: {
      TargetPressure: {
        // 0: 19.5,
        // 1: -9,
        // 2: 4
        0: 30,
        1: -9,
        2: 20,
        3: 25,
      },
    },
  },
  defaultSequenceTemplate: {
    Id: '-1', // ignore compare
    Sequence: 'prime', // ignore to compare
    Repeat: 7,
    Active: true,
    Running: false,
    SequenceParams: {
      Hi: {
        [APPDATA.KEY.DiaphragmTimingOpen]: '275',
        [APPDATA.KEY.DiaphragmTimingClose]: '275',
        [APPDATA.KEY.ValveTiming]: '25',
      },
      Lo: {
        [APPDATA.KEY.DiaphragmTimingOpen]: '500',
        [APPDATA.KEY.DiaphragmTimingClose]: '500',
        [APPDATA.KEY.ValveTiming]: '50',
      },
    },
    PressureState: {
      PressureType: 'Lo',
      PressureConfig: {
        Hi: [50, -9.25, 40, 15],
        Lo: [30, -9, 10, 18],
      },
    },
    RepeatType: RUN_TIME_MODE.TIMES.VALUE,
    TempRepeat: 1,
  },
  // wifi
  /**
   * @deprecated current state of wifi status will be handled by the derived context
   */
  wifiStatus: APPDATA.WIFI_STATUS.ON,
  /**
   * @deprecated current state of wifi list will be handled by the derived context
   */
  allWifiList: [],
  /**
   * @deprecated current state of connected wifi will be handled by the derived context
   */
  currentWifiConnected: undefined,
  errorParams: null,
  isCycleFinish: false,
  CustomOperation: {...INITIAL_CUSTOM_OPERATION},
  cleaningCustomOperation: {...INITIAL_CUSTOM_OPERATION},
  /**
   * @deprecated the reducer has been moved into deviceStore
   */
  isShuttingdown: false,
  isFromStopProfile: false,
  isRecoveryClicked: false,
  isRecalibration: false,
  isRecoveryFromErrorProfile: false,
};

/**
 * Mostly used to stored current operation state (Auto Profile, Manual Profile / Cleaning Process as part of Custom Operation)
 * @param {initialState} state
 * @param {Object} action
 * @param {setupActionsType} action.type {@link setupActionsType}
 * @param {*} action.value
 * @returns
 */
export default function setupStore(state = initialState, action = {}) {
  // consoleLog("Setup Store ", action);
  const {
    titleMenuProperties,
    isShowActiveMenu,
    isShowTopButton,
    isSecondaryButton,
    topButtonProperties,
    topButtonSecondaryButtonProperties,
    backButtonProperties,
    button1Properties,
    button2Properties,
  } = action.value ? action.value : {};

  switch (action.type) {
    case setupActionsType.INIT_VALUE:
      return {...state, ...action.value};

    case setupActionsType.UPDATE_ALL_VALUE:
      return {...state, ...action.value};

    case setupActionsType.UPDATE_AUTO_PROFILE_SETUP_MODE:
      if (action.value) {
        return {...state, autoProfileSetupMode: action.value};
      }
      break;

    case setupActionsType.UPDATE_AUTO_PROFILE_DIAFILTRATION_MODE:
      if (action.value) {
        return {...state, autoProfileDiafiltrationMode: action.value};
      }
      break;

    case setupActionsType.RUN_PROTEIN_CONCENTRATOR:
      return {
        ...state,
        isPCRunning: action.value.isPCRunning,
        errorMessage: action.value.errorMessage,
      };
    case setupActionsType.SAVE_DEVICE_VERSION:
      return {
        ...state,
        deviceVersion: action.value,
      };

    case setupActionsType.PAUSE_PROTEIN_CONCENTRATOR:
      return {
        ...state,
        isPCPaused: action.value.isPCPaused,
        errorMessage: action.value.errorMessage,
      };

    case setupActionsType.STOP_PROTEIN_CONCENTRATOR:
      return {
        ...state,
        isPCRunning: false,
        priming: true,
      };

    case setupActionsType.UPDATE_IS_MANUAL_PROFILE_RUNNING:
      return {...state, isManualProfileRunning: action.value};

    case setupActionsType.UPDATE_IS_MANUAL_PROFILE_PAUSED:
      return {...state, isManualProfilePaused: action.value};

    case setupActionsType.UPDATE_DIAFILTRATION_STATUS:
      return {
        ...state,
        dialfiltrationStatus: {...state.dialfiltrationStatus, ...action.value},
      };

    case setupActionsType.UPDATE_SHOW_REFILL_BUFFER:
      return {...state, isShowRefillBufferPopUp: action.value};

    case setupActionsType.UPDATE_SHOW_THRESHOLD_ERROR:
      return {...state, isShowThresholdErrorPopUp: action.value};

    case setupActionsType.UPDATE_PC_STATE:
      if (action.value && action.value !== state.currentPCState) {
        return {
          ...state,
          currentPCState: action.value,
          prevPCState:
            state.currentPCState !== APPDATA.PC_DEPRESSURIZING_STATE ? state.currentPCState : state.prevPCState,
        };
      }
      break;

    case setupActionsType.CHECK_PROFILE_PARAM:
      return {
        ...state,
        checkProfileParam: action.value.checkProfileParam,
        srcCheckProfileParam: action.value.srcCheckProfileParam,
      };

    // -------------------------------------------------
    // Advanced Setup
    // --------------------------------------------------
    case setupActionsType.UPDATE_DIAPHRAGM_VACUUM_PRESSURE:
      if (action.value) {
        return {...state, diaphragmVacuumPressure: action.value};
      }
      break;

    case setupActionsType.UPDATE_DIAPHRAGM_PRESSURE:
      if (action.value) {
        return {...state, diaphragmPressure: action.value};
      }
      break;

    case setupActionsType.UPDATE_DIAPHRAGM_TIMING:
      if (action.value) {
        return {...state, diaphragmTiming: action.value};
      }
      break;

    case setupActionsType.UPDATE_VALVE_TIMING:
      if (action.value) {
        return {...state, valveTiming: action.value};
      }
      break;

    case setupActionsType.UPDATE_SHOW_WARNING:
      if (action.value) {
        const {showWarning, errorMessage} = action.value;
        return {
          ...state,
          showWarning,
          errorMessage: errorMessage !== undefined ? errorMessage : initialState.errorMessage,
        };
      }
      break;

    case setupActionsType.AUTO_CALIBRATE:
      if (action.value) {
        return {...state, autoCalibrate: action.value};
      }
      break;

    case setupActionsType.RESET_TO_DEFAULT:
      if (action.value) {
        return {
          ...state,
          diaphragmVacuumPressure: action.value.diaphragmVacuumPressure,
          diaphragmPressure: action.value.diaphragmPressure,
          diaphragmTiming: action.value.diaphragmTiming,
          valveTiming: action.value.valveTiming,
        };
      }
      break;

    // STATUS
    case setupActionsType.SET_INVALID_AUTO_PROFILE_PARAMS:
      return {
        ...state,
        invalidAutoProfileParams: action.value,
      };

    case setupActionsType.UPDATE_PERCENTAGE_PROGRESS_BAR:
      return {
        ...state,
        percentageProgressBar: action.value,
      };

    case setupActionsType.UPDATE_ESTIMATE_TIME:
      return {
        ...state,
        estimateTime: action.value,
      };

    case setupActionsType.UPDATE_PROGRESSBAR_STATUS:
      return {
        ...state,
        progressBarStatus: action.value,
      };

    case setupActionsType.UPDATE_STATUS:
      return {
        ...state,
        currentVolumeChangesThreshold:
          action.value.currentVolumeChangesThreshold === null
            ? initialState.currentVolumeChangesThreshold
            : action.value.currentVolumeChangesThreshold,
        ErrorVolumeChanges: {...state.ErrorVolumeChanges, ...action.value.ErrorVolumeChanges},
        currentPressureSensors: {...state.currentPressureSensors, ...action.value.currentPressureSensors},
        currentPressure: action.value.currentPressure,
        pumpFlowRate: action.value.pumpFlowRate,
        currentVolume: action.value.currentVolume,
        currentBuffer: action.value.currentBuffer,
        estimateConcentration: action.value.estimateConcentration,
        estSecondsRemaining: action.value.estSecondsRemaining,
        secondsElapsed: action.value.secondsElapsed,
        warningMessage: action.value.warningMessage,
        failureMessage: action.value.failureMessage,
        concentrationFlowRate: action.value.concentrationFlowRate,
        profileRunning: {...state.profileRunning, ...action.value.profileRunning},
        advSetupChoosen: {...state.advSetupChoosen, ...action.value.advSetupChoosen},
        currentTiming: {...state.currentTiming, ...action.value.currentTiming},
        transferVolume: action.value.transferVolume,
        requireRefill: action.value.requireRefill,
      };

    case setupActionsType.UPDATE_RECOVERY_STATUS:
      return {
        ...state,
        recoveryOfLiquidStatus: {...state.recoveryOfLiquidStatus, ...action.value},
      };

    case setupActionsType.UPDATE_STOPPING_FROM_BUTTON:
      return {...state, isStopingFromButton: action.value};

    case setupActionsType.UPDATE_ACTIVE_MENU:
      return {
        ...state,
        // isShowActiveMenu: true,
        activeMenu: action.value,
      };

    case setupActionsType.UPDATE_DEFAULT_CONFIG_PARAMS:
      return {...state, defaultConfigParams: action.value};

    case setupActionsType.UPDATE_DEFAULT_CONFIG_ADV_SETUP_PARAMS:
      return {...state, defaultConfigAdvSetupParams: action.value};

    case setupActionsType.UPDATE_DEFAULT_RETURN_VALVE_PRESSURE_PARAMS:
      return {...state, defaultReturnValvePressure: action.value};

    // refill buffer
    case setupActionsType.UPDATE_REFILL_BUFFER_VOLUME:
      return {...state, refilledBufferVolume: action.value};

    case setupActionsType.IS_UPDATE_SESOR_REFILL_BUFFER:
      return {...state, isNeedUpdateSensorModalRefillBuffer: action.value};

    // Explorer
    case setupActionsType.UPDATE_PROFILE_LIST:
      return {...state, updateProfileList: action.value};

    case setupActionsType.SET_PROFILE_LIST:
      if (action.value) {
        return {...state, profileList: action.value};
      }
      break;

    case setupActionsType.PROFILE_SELECTED:
      return {...state, profileSelected: action.value};

    case setupActionsType.UPDATE_PROFILE_NAME:
      if (action.value) {
        const {profileName, profileAddress} = action.value;
        return {
          ...state,
          profileName: profileName || state.profileName,
          profileAddress: profileAddress || state.profileAddress,
        };
      }
      break;

    case setupActionsType.PROFILE_SETTING_EXPLORER:
      if (action.value) {
        return {...state, profileSettingExplorer: action.value};
      }
      break;

    case setupActionsType.UPDATE_SHOW_PROFILE:
      if (action.value) {
        return {...state, showProfile: action.value};
      }
      break;

    case setupActionsType.UPDATE_LAST_PROFILE_ID_VIEW:
      return {...state, lastProfileIdView: action.value};

    case setupActionsType.RESET_PREVIEW_PROFILE:
      return {...state, resetPreviewProfile: action.value};

    case setupActionsType.SAVE_PROFILE:
      return {...state, saveProfile: action.value};

    case setupActionsType.UPDATE_CURRENT_PROFILE_PARAM:
      console.log(' action.value :', action.value);
      return {
        ...state,
        currentProfileParams: action.value,
      };

    case setupActionsType.TEMPLATE_NEW_PROFILE:
      return {...state, templateNewProfile: action.value};

    // Auto Profile
    case setupActionsType.COMPLETE_PROFILE_FILL:
      return {...state, isCompleteFill: action.value};

    // case setupActionsType.SHOW_RECOVERY_LOADING:
    // 	return { ...state, isShowRecoveryLoading: action.value };

    case setupActionsType.IS_FINISH_RECOVERY:
      return {...state, isFinishRecovery: action.value};

    // Advance Setup Explorer
    case setupActionsType.UPDATE_ADV_SETUP_LIST:
      return {...state, updateAdvSetupList: action.value};

    case setupActionsType.SET_ADV_SETUP_LIST:
      if (action.value) {
        return {...state, advSetupList: action.value};
      }
      break;

    case setupActionsType.ADV_SETUP_SELECTED:
      return {...state, advSetupSelected: action.value};

    case setupActionsType.UPDATE_ADV_SETUP_NAME:
      if (action.value) {
        const {advSetupName, advSetupAddress} = action.value;
        return {
          ...state,
          advSetupName: advSetupName || state.advSetupName,
          advSetupAddress: advSetupAddress || state.advSetupAddress,
        };
      }
      break;

    case setupActionsType.ADV_SETUP_SETTING_EXPLORER:
      if (action.value) {
        return {...state, advSetupSettingExplorer: action.value};
      }
      break;

    case setupActionsType.UPDATE_SHOW_ADV_SETUP:
      if (action.value) {
        return {...state, showAdvSetup: action.value};
      }
      break;

    case setupActionsType.UPDATE_LAST_ADV_SETUP_ID_VIEW:
      return {...state, lastAdvSetupIdView: action.value};

    case setupActionsType.UPDATE_LAST_ADV_SETUP_ID_CREATED:
      return {...state, lastAdvSetupIdCreated: action.value};

    case setupActionsType.RESET_PREVIEW_ADV_SETUP:
      return {...state, resetPreviewAdvSetup: action.value};

    case setupActionsType.SAVE_ADV_SETUP:
      return {...state, saveAdvSetup: action.value};

    case setupActionsType.SET_BUTTON_TYPE_ADV:
      return {...state, buttonTypeAdv: action.value};

    case setupActionsType.UPDATE_CURRENT_ADV_SETUP_PARAM:
      return {
        ...state,
        currentAdvSetupParams: action.value,
      };

    case setupActionsType.TEMPLATE_NEW_ADV_SETUP:
      return {...state, templateNewAdvSetup: action.value};

    case setupActionsType.EDIT_ADV_SETUP:
      return {...state, editAdvSetup: action.value};

    case setupActionsType.DISABLE_SAVE_SETUP_BUTTON:
      return {...state, disableSaveSetupButton: action.value};

    case setupActionsType.UPDATE_ALL_VALUE_ADV_SETUP:
      if (action.value) {
        return {
          ...state,
          bufferVolumeToUse: action.value.bufferVolumeToUse,
          diafiltrationMode: action.value.diafiltrationMode,
          diaphragmPressure: action.value.diaphragmPressure,
          diaphragmTiming: action.value.diaphragmTiming,
          diaphragmVacuumPressure: action.value.diaphragmVacuumPressure,
          estimatedFinalConcentration: action.value.estimatedFinalConcentration,
          finalVolume: action.value.finalVolume,
          flowRate: action.value.flowRate,
          operatingPressure: action.value.operatingPressure,
          primeTiming: action.value.primeTiming,
          recoveryOfLiquid: action.value.recoveryOfLiquid,
          startingVolume: action.value.startingVolume,
          startingConcentration: action.value.startingConcentration,
          valveTiming: action.value.valveTiming,
          volumeToStartAt: action.value.volumeToStartAt,
          dummyBuffer: action.value.dummyBuffer,
          dummyVolume: action.value.dummyVolume,
        };
      }
      break;

    case setupActionsType.SHOW_ALERT:
      if (action.value) {
        const {alertShow, alertText, alertStyle} = action.value;
        return {
          ...state,
          alertShow,
          alertText: alertText !== undefined ? alertText : initialState.alertText,
          alertStyle: alertStyle !== undefined ? alertStyle : initialState.alertStyle,
        };
      }
      break;
    // case setupActionsType.SHOW_LOADING:
    // 	return { ...state, showLoading: action.value, loadingText: "Loading..." };

    // case setupActionsType.UPDATE_LOADING:
    // 	return {
    // 		...state,
    // 		showLoading: action.value.showLoading,
    // 		loadingText: action.value.loadingText,
    // 		loadingClickEvent: action.value.loadingClickEvent,
    // 		loadingButton: action.value.loadingButton,
    // 	};

    // save config
    case setupActionsType.SAVE_CYCLE_THRESHOLD:
      return {...state, saveCycleThreshold: action.value};

    // top menu
    case setupActionsType.BACK_BUTTON_PROPERTIES:
      return {
        ...state,
        // backButtonProperties: action.value === undefined ? state.defaultBackButtonProperties : action.value,
        backButtonProperties: action.value,
      };

    case setupActionsType.TOP_BUTTON_PROPERTIES:
      return {
        ...state,
        topButtonProperties: action.value === undefined ? state.defaultTopButtonProperties : action.value,
      };
    case setupActionsType.SET_DISABLED_TOP_BUTTON_PROPERTIES:
      return {
        ...state,
        topButtonProperties: {
          ...state.topButtonProperties,
          disabled: action.value,
        },
      };
    case setupActionsType.TOP_BUTTON_SECONDARY_PROPERTIES:
      return {
        ...state,
        isSecondaryButton: action.value !== undefined,
        topButtonSecondaryButtonProperties: action.value,
      };

    case setupActionsType.TOP_BUTTON_TERTIARY_PROPERTIES:
      return {
        ...state,
        isTertiaryButton: action.value !== undefined,
        topButtonTertiaryButtonProperties: action.value,
      };

    case setupActionsType.SET_TITLE_MENU_PROPERTIES:
      return {
        ...state,
        titleMenuProperties: action.value,
      };

    case setupActionsType.SET_TOP_MENU_PROPERTIES:
      return {
        ...state,
        isDoubleButton: false,
        isShowActiveMenu:
          isShowActiveMenu === undefined
            ? !!(titleMenuProperties === undefined || titleMenuProperties === '')
            : isShowActiveMenu,
        isShowTopButton: isShowTopButton === undefined ? topButtonProperties !== undefined : isShowTopButton,
        isSecondaryButton:
          isSecondaryButton === undefined ? topButtonSecondaryButtonProperties !== undefined : isSecondaryButton,
        // isTertiaryButton: action.value.isTertiaryButton === undefined ? (action.value.topButtonTertiaryButtonProperties === undefined ? false : true) : action.value.isTertiaryButton,
        topButtonProperties: topButtonProperties === undefined ? state.defaultTopButtonProperties : topButtonProperties,
        backButtonProperties,
        titleMenuProperties,
        topButtonSecondaryButtonProperties,
        // topButtonTertiaryButtonProperties: action.value.topButtonTertiaryButtonProperties,
      };

    case setupActionsType.SET_DOUBLE_TOP_MENU_PROPERTIES:
      return {
        ...state,
        isDoubleButton: true,
        isShowActiveMenu:
          isShowActiveMenu === undefined
            ? !!(titleMenuProperties === undefined || titleMenuProperties === '')
            : isShowActiveMenu,
        isShowTopButton:
          isShowTopButton === undefined
            ? !(button1Properties === undefined && button2Properties === undefined)
            : isShowTopButton,
        isSecondaryButton:
          isSecondaryButton === undefined ? topButtonSecondaryButtonProperties !== undefined : isSecondaryButton,
        // isTertiaryButton: action.value.isTertiaryButton === undefined ? (action.value.topButtonTertiaryButtonProperties === undefined ? false : true) : action.value.isTertiaryButton,
        button1Properties: button1Properties === undefined ? state.defaultTopButtonProperties : button1Properties,
        button2Properties: button2Properties === undefined ? state.defaultTopButtonProperties : button2Properties,
        backButtonProperties,
        titleMenuProperties,
        topButtonSecondaryButtonProperties,
        // topButtonTertiaryButtonProperties: action.value.topButtonTertiaryButtonProperties,
      };

    case setupActionsType.UPDATE_LOCK_ACESS:
      return {...state, lockAccess: action.value};

    case setupActionsType.MODIFY_PROFILE:
      return {...state, modifyProfile: action.value};

    case setupActionsType.MODIFY_ADV_SETUP:
      return {...state, modifyAdvSetup: action.value};

    // info and support
    case setupActionsType.UPDATE_FONT_SIZE:
      return {...state, fontSize: parseInt(action.value, 10)};

    // usbfile Open
    case setupActionsType.IS_OPEN_FILE:
      return {...state, isOpenFile: action.value};

    case setupActionsType.USB_PROPERTIES:
      return {...state, usbProperties: action.value};

    case setupActionsType.USB_OPEN_FOR:
      return {...state, usbOpenFor: action.value};

    case setupActionsType.SELECTED_FILE_UPDATE:
      return {...state, selectedFileUpdate: action.value};

    case setupActionsType.SELECTED_FILE_EXPORT:
      return {...state, selectedFileExport: action.value};

    case setupActionsType.SELECTED_DATE_BEGIN_EXPORT:
      return {...state, selectedDateBeginExport: action.value};

    case setupActionsType.SELECTED_DATE_END_EXPORT:
      return {...state, selectedDateEndExport: action.value};

    case setupActionsType.SELECTED_FOLDER_EXPORT_DESTINATION:
      return {...state, selectedFolderExportDestination: action.value};

    case setupActionsType.EXPAND_ACCORDION_STATUS:
      return {...state, expandAccordionStatus: action.value};

    // wizard component
    case setupActionsType.NEXT_ACTION_WIZARD:
      return {...state, nextActionWizard: action.value};

    case setupActionsType.PREV_ACTION_WIZARD:
      return {...state, prevActionWizard: action.value};

    // cleaning duration
    case setupActionsType.SET_CLEANING_PROPERTIES:
      return {...state, cleaningProperties: {...state.cleaningProperties, ...action.value}};

    case setupActionsType.UPDATE_MESSAGE_AUTO_PROFILE_HELP:
      return {
        ...state,
        modeHelp: action.value,
      };

    // pressure param
    case setupActionsType.UPDATE_DEFAULT_HIGH_PRESSURE_PARAM:
      if (action.value) {
        return {...state, defaultHighPressureParam: action.value};
      }
      break;

    case setupActionsType.UPDATE_DEFAULT_LOW_PRESSURE_PARAM:
      if (action.value) {
        return {...state, defaultLowPressureParam: action.value};
      }
      break;
    case setupActionsType.UPDATE_DEFAULT_HIGH_SEQUENCE_PARAM:
      if (action.value) {
        return {...state, defaultHighSeqParam: action.value};
      }
      break;

    case setupActionsType.UPDATE_DEFAULT_LOW_SEQUENCE_PARAM:
      if (action.value) {
        return {...state, defaultLowSeqParam: action.value};
      }
      break;

    case setupActionsType.UPDATE_DEFAULT_PRESSURE_TEMPLATE:
      if (action.value) {
        return {...state, defaultPressureTemplate: action.value};
      }
      break;

    case setupActionsType.UPDATE_DEFAULT_SEQUENCE_TEMPLATE:
      return {
        ...state,
        defaultSequenceTemplate: {...state.defaultSequenceTemplate, ...action.value},
      };

    case setupActionsType.UPDATE_CURRENT_IS_MORE_THAN_50_ML:
      return {...state, currentIsMoreThan50ml: action.value};

    case setupActionsType.UPDATE_WIFI_STATUS:
      return {...state, wifiStatus: action.value};

    case setupActionsType.UPDATE_WIFI_LIST:
      return {...state, allWifiList: action.value};

    case setupActionsType.SET_CURRENT_WIFI_CONNECTED:
      return {...state, currentWifiConnected: action.value};

    case setupActionsType.UPDATE_WIFI:
      return {
        ...state,
        wifiStatus: action.value.wifiStatus ? action.value.wifiStatus : state.wifiStatus,
        currentWifiConnected: action.value.currentWifiConnected
          ? action.value.currentWifiConnected
          : state.currentWifiConnected,
        allWifiList: action.value.allWifiList ? action.value.allWifiList : state.allWifiList,
      };

    case setupActionsType.IS_SHUTTINGDOWN:
      return {...state, isShuttingdown: action.value};

    case setupActionsType.ERROR_PARAMS:
      return {...state, errorParams: action.value};

    case setupActionsType.CYCLE_FINISH:
      return {...state, isCycleFinish: action.value};

    case setupActionsType.CUSTOM_OPERATION.SET:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, ...action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.OPERATION_LIST:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, Operations: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.TEMP_OPERATION_LIST:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, TempOperations: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.NAME:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, Name: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.FILE_NAME:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, FileName: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.CONTENT_CHANGED:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, ContentChanged: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.IS_DEPRESSURIZED_AT_THE_END:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, IsDepressurizedAtTheEnd: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.REPEAT:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, Repeat: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.REPEATED:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, Repeated: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.DEFAULT_PRIME_PARAM:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, DefaulthPrimeParam: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.STATUS:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, Status: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.MESSAGE:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, Message: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.TIME_ELAPSED:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, TimeElapsed: action.value},
      };

    case setupActionsType.CUSTOM_OPERATION.PRELOADED:
      return {
        ...state,
        CustomOperation: {...state.CustomOperation, IsPreloaded: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.SET:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, ...action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.OPERATION_LIST:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, Operations: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.TEMP_OPERATION_LIST:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, TempOperations: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.NAME:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, Name: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.IS_DEPRESSURIZED_AT_THE_END:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, IsDepressurizedAtTheEnd: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.REPEAT:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, Repeat: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.REPEATED:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, Repeated: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.DEFAULT_PRIME_PARAM:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, DefaulthPrimeParam: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.STATUS:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, Status: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.MESSAGE:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, Message: action.value},
      };

    case setupActionsType.CLEANING_CUSTOM_OPERATION.TIME_ELAPSED:
      return {
        ...state,
        cleaningCustomOperation: {...state.cleaningCustomOperation, TimeElapsed: action.value},
      };

    case setupActionsType.IS_STOP_FROM_PROFILE:
      return {
        ...state,
        isFromStopProfile: action.value,
      };

    case setupActionsType.IS_RECOVERY_FROM_ERROR_PROFILE:
      return {
        ...state,
        isRecoveryFromErrorProfile: action.value,
      };

    case setupActionsType.IS_RECOVERY_CLICKED:
      return {
        ...state,
        isRecoveryClicked: action.value,
      };

    case setupActionsType.IS_RECALIBRATION:
      return {
        ...state,
        isRecalibration: action.value,
      };
    case setupActionsType.SET_PROFILE_RUNNING:
      return {
        ...state,
        profileRunning: {...state.profileRunning, ...action.value},
      };
    case setupActionsType.SET_CURRENT_BUFFER:
      return {
        ...state,
        currentBuffer: action.value,
      };
    case setupActionsType.SET_CURRENT_VOLUME:
      return {
        ...state,
        currentVolume: action.value,
      };
    case setupActionsType.SET_REQUIRE_REFILL:
      return {
        ...state,
        requireRefill: action.value,
      };

    default:
      return state;
  }

  return state;
}
